"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*eslint-disable react/no-danger*/
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const Cancel_1 = __importDefault(require("@kyruus/react-ikons/Cancel"));
const Markdown_1 = __importDefault(require("../Markdown"));
const banner_1 = __importDefault(require("@kyruus/banner"));
const AlertBanner = (_a) => {
    var { children, onClose } = _a, props = __rest(_a, ["children", "onClose"]);
    return (react_1.default.createElement(banner_1.default, Object.assign({}, props, { type: "alert", icon: "!", action1Text: react_1.default.createElement(Cancel_1.default, null), action1: "close", onClose: onClose }), children));
};
const EmergencyDisclaimer = ({ config, onClose, onClick }) => {
    var _a, _b;
    const { enabled: showMd, markdown } = ((_a = config === null || config === void 0 ? void 0 : config.direct_book) === null || _a === void 0 ? void 0 : _a.emergency_disclaimer_md) || {};
    const { enabled: showText, text } = ((_b = config === null || config === void 0 ? void 0 : config.direct_book) === null || _b === void 0 ? void 0 : _b.emergency_disclaimer_text) || {};
    return showMd ? (react_1.default.createElement(styles_1.Container, { "data-testid": "emergency-disclaimer" },
        react_1.default.createElement(AlertBanner, { onClose: onClose },
            react_1.default.createElement(Markdown_1.default, { markdown: markdown, onClick: onClick })))) : showText ? (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement(AlertBanner, null, text))) : null;
};
exports.default = EmergencyDisclaimer;
//# sourceMappingURL=EmergencyDisclaimer.js.map